<template>
  <CrmLayout />
</template>

<script>
import CrmLayout from '../../components/adminCrm/layout/CrmContent'
export default {
  components: {
    CrmLayout,
  },
}
</script>
